const POPOVER_WIDTH = 280;
const POPOVER_OFFSET = 16;
const PIN_RADIUS = 12;
const VIEWPORT_PADDING = 8;
const MIN_HEIGHT = 120;

type VerticalStyle =
  | { top: number; bottom?: undefined }
  | { bottom: number; top?: undefined };

export function usePinPopoverPosition(
  anchorX: number,
  anchorY: number,
  /** Width taken up on the right, e.g. the open comments panel. */
  rightInset = 0,
) {
  const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 800;

  // Horizontal: prefer right of pin, flip left if it would overflow
  let left = anchorX + PIN_RADIUS + POPOVER_OFFSET;
  if (left + POPOVER_WIDTH > vw - rightInset - VIEWPORT_PADDING) {
    left = anchorX - PIN_RADIUS - POPOVER_OFFSET - POPOVER_WIDTH;
  }
  left = Math.max(VIEWPORT_PADDING, left);

  // Vertical: open downward or upward based on available space
  const spaceBelow = vh - (anchorY - PIN_RADIUS) - VIEWPORT_PADDING;
  const spaceAbove = anchorY + PIN_RADIUS - VIEWPORT_PADDING;

  let verticalStyle: VerticalStyle;
  let maxHeight: number;

  if (spaceBelow >= spaceAbove) {
    // Anchor top of popover to top of pin, grow downward
    const top = Math.max(VIEWPORT_PADDING, anchorY - PIN_RADIUS);
    maxHeight = Math.max(vh - top - VIEWPORT_PADDING, MIN_HEIGHT);
    verticalStyle = { top };
  } else {
    // Anchor bottom of popover to bottom of pin, grow upward
    const bottom = Math.max(VIEWPORT_PADDING, vh - (anchorY + PIN_RADIUS));
    maxHeight = Math.max(anchorY + PIN_RADIUS - VIEWPORT_PADDING, MIN_HEIGHT);
    verticalStyle = { bottom };
  }

  return { left, verticalStyle, width: POPOVER_WIDTH, maxHeight };
}
